import NoteEvent from "../chart/events/NoteEvent";
export default class Difficulty {
    static beatbox(timeline, rate = 1) {
        if (rate < 0.01)
            rate = 0.01;
        var notes = [];
        timeline.forEach(val => {
            if (val instanceof NoteEvent && !val.FAKE) {
                const adjustedTime = Math.floor((Math.round((val.TIME + 2000) / rate)) + ((-1 / 30) * 1000));
                const adjustedFrame = 60 + Math.round((val.TIME / (1000 / 30)) / rate) + -1;
                notes.push([adjustedFrame, val.COLUMN, val.COLOR, adjustedTime]);
            }
        });
        return notes;
    }
    static estimate(timeline, rate = 1) {
        return new Promise(async (resolve, reject) => {
            const notes = Difficulty.beatbox(timeline, rate);
            await fetch('https://uxswva20wb.execute-api.us-east-1.amazonaws.com/prod/autodifficulty', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ "operation": "predict_difficulty", "payload": notes }),
            }).then((response) => {
                resolve(response.text());
            }, (reason) => {
                reject(reason);
            });
        });
    }
}
